<div class="abtest-settings">
  <div class="container">
    <form [formGroup]="formGroup">
      <div class="header">
        <pdq-heading element="h5">A/B testing global settings</pdq-heading>
      </div>

      <div class="content">
        <pdq-checkbox
          label="Run all B variants together"
          labelSize="small"
          formControlName="runTestVariantsTogether"></pdq-checkbox>

        @if (formGroup.value['runTestVariantsTogether']) {
          <div class="content">
            <span
              >percent of traffic to send to new variant
              <img
                src="assets/icons/icon-info.svg"
                matTooltip="the percentage here will override the percentage mentioned per method AB test and will determine the traffic that will be sent to all active B variants"
                matTooltipClass="pdq-mat-tooltip"
            /></span>
            <pdq-input-arrows
              [formControl]="formGroup.controls['percentTestVariantTraffic']"
              [min]="0"
              [max]="100"
              width="360"
              widthSize="auto"
              placeholder="50"
              symbol="%"></pdq-input-arrows>
          </div>
        }
      </div>
    </form>
  </div>
</div>
